//material ui
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';

//material icon
import StarBorderIcon from '@mui/icons-material/StarBorder';

//types
import { amenityType } from '../api/amenities/type/AmenitiesType';

//translate
import { useTranslation } from 'react-i18next';
import i18n from '../translate/i18n';

//swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

//css file
import styles from "../Component/RoomCard/RoomCard.module.css"

const storageURL = process.env.REACT_APP_STORAGE_BASE_URL;


interface AmenitiesDetailsProps {
    element: amenityType
    setBookingRequest: (bookingRequest: {cardId: number | null; open: boolean , type: string}) => void

}
const AmenitiesDetailsCard = ({element, setBookingRequest} :AmenitiesDetailsProps) => {
    const {t} = useTranslation()
  return (
    <Card className='py-5 px-2'>
      <CardActionArea className={i18n.language === "en" ? `ltrSwiper ${styles.ltrSwiper}` : `rtlSwiper ${styles.rtlSwiper}`}>
          <Swiper
          spaceBetween={30}
          navigation
          pagination={{ clickable: true }}
          modules={[Navigation, Pagination]}
          className={`roomCardSwiper ${styles.roomCardSwiper}`}
        >
          {element.imageable?.map((element, index) => (
            <SwiperSlide 
            className="
            !flex 
            justify-center 
            items-center 
            rounded-[20px]" 
            key={index}>
              <CardMedia
              component="img"
              image={`${storageURL}/${element.url}`}
              className='h-[250px] !object-left-bottom p-3 !rounded-[20px]'
              alt="no_photo"
              />
            </SwiperSlide>
          ))}
        </Swiper>
            <CardContent>
                <Typography className={`${i18n.language === "en" ? "!text-left" : "!text-right"} ${i18n.language === "en" ? "!font-palab" : "!font-helvetica-arabic-bold"} !text-primaryColor !mb-5`} variant="h5" component="div">
                    {element.name}
                </Typography>
                <Typography component='div'>
                        {element.specifications?.map((element, index)=>{
                            return(
                                <div key={index} className='flex gap-3 mb-2'>
                                    <p><StarBorderIcon className='text-secondaryColor'/></p>
                                    <p className='text-primaryColor !text-left'>{`${element.title} : ${element.value}`}</p>
                                </div>
                            )
                        })}
                </Typography>
            </CardContent>
            {element.can_be_booked
            ?
            <CardActions>
                <Button onClick={()=>setBookingRequest({cardId: element.id, open: true, type: "public_facility"})} className={`${i18n.language === "en" ? "!font-helvetica-light" : "!font-helvetica-arabic-light"} !bg-primaryColor !text-white w-full !capitalize !text-[17px]`}>
                    {t("request_booking")}
                </Button>
            </CardActions>
            :<></>
            }
      </CardActionArea>
    
    </Card>
  )
}

export default AmenitiesDetailsCard



